export default __webpack_public_path__ + "static/media/man.a5a9aaac.svg";